import React, { FC, useEffect } from 'react'
import { motion, useInView } from 'framer-motion'

interface ReliabilityHosIntranetProps {
    hospitalIntranetData: any
}

const ReliabilityHosIntranet: FC<ReliabilityHosIntranetProps> = ({ hospitalIntranetData }) => {
    // Animation variants for staggered children
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    }

    const item = {
        hidden: { opacity: 0, y: 20 },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    }

    // Card animation variants with better scroll response
    const itemVariants = {
        hidden: { y: 10, opacity: 0 },
        visible: (i: number) => ({
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 80,
                damping: 12,
                delay: i * 0.1, // Staggered delay based on index
            }
        })
    }


    return (
        <motion.div
            className='grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8 lg:gap-12 p-4 sm:p-8 lg:p-12 xl:px-36'
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
        >
            {hospitalIntranetData.ReliabilityHoshIntraData.map((reliable: any, index: number) => {
                return (
                    <motion.div
                        key={index}
                        className='group bg-darkGreyPrimary rounded-2xl flex flex-col items-center justify-between overflow-hidden relative transition-all '
                        variants={item}
                    >
                        <motion.div className='bg-blackDark flex flex-col rounded-xl relative p-4 sm:p-6 w-full h-full'
                            whileHover={{
                                background: `linear-gradient(145.33deg, ${reliable.bgColor}24, #1B1B1B 29.24%)`,
                                borderBottomWidth: '2px',
                                borderBottomStyle: 'solid',
                                borderBottomColor: `${reliable.bgColor}`,
                            }}>
                            <div className={`text-lg sm:text-xl text-start font-semibold mb-2 text-white`}>{reliable.title}</div>
                            <div className='text-lightGrey text-start text-xs sm:text-sm'>{reliable.subtitle}</div>

                        </motion.div>

                    </motion.div>
                )
            })}
        </motion.div>
    )
}

export default ReliabilityHosIntranet
